import { parseSafeAreaInsets } from './parseSafeAreaInsets'

export const createEnvSafeAreaInsetsProbe = () => {
  const element = document.createElement('div')

  element.setAttribute('aria-hidden', 'true')

  Object.assign(element.style, {
    position: 'fixed',
    top: '0',
    left: '0',
    width: '0',
    height: '0',
    margin: '0',
    border: '0',
    visibility: 'hidden',
    pointerEvents: 'none',
    padding:
      'env(safe-area-inset-top) env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left)',
  })

  document.body.appendChild(element)

  return {
    read: () => parseSafeAreaInsets(getComputedStyle(element)),
    remove: () => element.remove(),
  }
}
